'use strict';

/**
 * @private
 * Represents a warning encountered when
 * interacting with one of Twilio's services.
 */
// eslint-disable-next-line
const TwilioWarning = {
  recordingMediaLost: 'recording-media-lost'
};

module.exports = TwilioWarning;
